import { combineEpics, type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { createMatchRequest } from '@/api/matches';
import { clearDailyMatches, createMatch } from '../actions';

const createMatchEpic: Epic = (action$) =>
  action$.pipe(
    filter(createMatch.match),
    request(({ payload }) => createMatchRequest(payload), createMatch),
  );

const createMatchSuccessEpic: Epic = (action$) =>
  action$.pipe(
    filter(createMatch.succeeded.match),
    mergeMap(() => [
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: 'Ο αγώνας δημιουργήθηκε με επιτυχία',
      }),
      clearDailyMatches(),
    ]),
  );

export default combineEpics(createMatchEpic, createMatchSuccessEpic);
